module.exports = __webpack_public_path__ + "img/DK38136216.a1dbf083.png";